/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description store for guarantors
 */
import { create } from 'zustand';
import _ from 'lodash';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { useShallow } from 'zustand/react/shallow';

const defaultPagination = {
	pageSize: 5,
	pageNumber: 1,
};

const initialState: Guarantor.IValues = {
	pageSize: defaultPagination.pageSize,
	pageNumber: defaultPagination.pageNumber,
	searchParams: {},
	apiParams: {},
};

const useGuarantorStore = create<Guarantor.IStore>()(
	persist(
		devtools(
			(set) => ({
				...initialState,
				actions: {
					resetStates: () =>
						set(() => ({
							pageSize: defaultPagination.pageSize,
							pageNumber: defaultPagination.pageNumber,
						})),

					setPageSize: (pageSize) => set(() => ({ pageSize })),
					setPageNumber: (pageNumber) => set(() => ({ pageNumber })),
					setSearchParams: (searchParams) => set(() => ({ searchParams })),
					setApiParams: (apiParams) =>
						set(() => ({ apiParams, pageSize: defaultPagination.pageSize, pageNumber: defaultPagination.pageNumber })),
				},
			}),
			{ name: 'Guarantors' },
		),
		{
			name: 'guarantors',
			storage: createJSONStorage(() => sessionStorage),
			partialize: (state) => ({
				pageSize: state.pageSize,
				searchParams: state.searchParams,
				apiParams: state.apiParams,
			}),
		},
	),
);

// store to return actions and values
const useGuarantorStoreValues = (): Guarantor.IValues => useGuarantorStore(useShallow((state) => _.omit(state, ['actions'])));
const useGuarantorStoreActions = (): Guarantor.IActions => useGuarantorStore(useShallow((state) => state.actions));

export { defaultPagination, useGuarantorStoreValues, useGuarantorStoreActions };
export default useGuarantorStore;
